export default function Heatmap() {
  return (
    <p>
      Renderer visual editor under work. Please edit it through json editor by
      pressing the "Renderer" button
    </p>
  );
}
